

























































































import { Component, Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class PunishmentWhen extends GlobalMixins {
	isInitializing: boolean = true
	hasInteractedWithDate: boolean = false

	@Watch('day')
	@Watch('month')
	@Watch('year')
	onDateChange() {
		if (this.isInitializing) return

		this.hasInteractedWithDate = true
		this.checkTimestampValid('setPunishmentWhen')
	}

	mounted() {
		bus.$emit('setNextButton', false)
		bus.$on('goToNextScreen', () => {
			this.$router.push({
				name: this.language === Languages.NL
					? 'punishment-length'
					: 'punishment-length-' + this.language
			})
		})

		window.onresize = () => {
			if (!this.windowResizeStagger) {
				this.windowResizeStagger = true
				this.isMobile = window.innerWidth < 768

				setTimeout(() => {
					this.windowResizeStagger = false
				}, 20)
			}
		}

		if (
			this.$store.getters.user.punishmentWhen &&
			this.$store.getters.user.punishmentWhen !== 'skipped'
		) {
			this.day = this.$store.getters.user.punishmentWhen.day
			this.month = this.monthIndexToString(
				this.$store.getters.user.punishmentWhen.month
			)
			this.year = this.$store.getters.user.punishmentWhen.year
		} else {
			this.day = false
			this.month = this.monthIndexToString(1)
			this.year = 1970
		}

		this.$nextTick(() => {
			this.isInitializing = false
			this.checkTimestampValid('setPunishmentWhen')
		})
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}
}
